import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import CollapseButton from '../../../utilities/CollapseButton/CollapseButton';
import {transactionType} from '../../Page/TransactionSummaryPage/Shared/Constants';
import {checkSectionValid} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';
import Property from '@episerver/spa-core/Components/Property';
import DocLogo from './assets/doc.svg';

const DocsAndImportantToKnow = ({data, context, docsAndImportantToKnow, dealType, generalDetails}) => {
  let docSummary;
  let cardTitle;
  let importantToKnow;

  const [isOpen, setIsOpen] = useState(false);
  const showComponent = checkSectionValid(docsAndImportantToKnow);

  if (showComponent) {
    docSummary = docsAndImportantToKnow.customerContractUri;
    cardTitle = data.docsAndImportantToKnowTopic.value === '' ? 'טפסים וחשוב לדעת' : data.docsAndImportantToKnowTopic.value;
    importantToKnow = setImportantToKnow(dealType);
  }

  /* const isEnergy = {
     marginTop: generalDetails.family == 'W' ? '70px' : '20px',
   }; */

  return showComponent ? (
    <div /*style={isEnergy}*/ className='block-frame p-2'>
      <CollapseButton cardTitle={cardTitle} setIsOpen={setIsOpen} isOpen={isOpen} />
      {isOpen && (
        <div className='block-frame__container'>
          <hr />
          <div className='docs-and-important-to-know'>
            {docSummary !== undefined && docSummary !== '' && dealType !== transactionType.Disconnect && (
              <React.Fragment>
                <label className='docs-and-important-to-know__sub-title docs-and-important-to-know__sub-title--1'>טפסים</label>
                <div className='docs-and-important-to-know__holder'>
                  <Image className='docs-and-important-to-know__logo' src={DocLogo} alt='' />
                  <a href={docSummary} className='docs-and-important-to-know__label' target='_blank'>
                    טופס מרכז
                  </a>
                </div>
              </React.Fragment>
            )}
            <label className='docs-and-important-to-know__sub-title docs-and-important-to-know__sub-title--2'>מידע חשוב!</label>
            <Property iContent={data} field={importantToKnow} context={context} />
          </div>
        </div>
      )}
    </div>
  ) : null;
};

function setImportantToKnow(dealType) {
  let result;

  switch (dealType) {
    case transactionType.Provide:
      result = 'importantToKnowProvide';
      break;
    case transactionType.Change:
      result = 'importantToKnowChange';
      break;
    case transactionType.Disconnect:
      result = 'importantToKnowDisconnect';
      break;
    default:
      result = 'importantToKnowProvide';
  }

  return result;
}

export default DocsAndImportantToKnow;
